const updateEquipmentModels = {
  toastr: 'Tipo de equipo actualizado',
  toastr1: 'fue actualizado con éxito',
  toastrError: 'Nombre ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default updateEquipmentModels;
